var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"chat",on:{"click":function($event){return _vm.$emit('click')}}},[_c('chatIcon',{staticClass:"chat__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }